import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'app-pages-banner',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false
})

export class AppPagesBanner {
  @Prop() bannerSpan: string;
  @Prop() bannerTitle: string;
  @Prop() titleContent: string;
  @Prop() bannerImage: string;
  @Prop() bannerImageWeb: string;
  @Prop() bannerImageSrc: string;

  render() {
    return <div class='pages-banner'>
        <div class='pages-banner-items'>
          <div class='pages-banner-item banner-info'>
            <div class='pages-banner-info'>
              <span>{ this.bannerSpan }</span>
              <h2>{ this.bannerTitle }</h2>
              <p>{ this.titleContent }</p>
            </div>
          </div>
          <div class='pages-banner-item banner-image'>
            <div class='pages-banner-image'>
              <picture>
                <source
                  media='(min-width:320px)'
                  srcSet={ this.bannerImageWeb }
                  type='image/webp'
                />

                <img
                  class='img'
                  src={ this.bannerImage }
                  srcset={ this.bannerImageSrc }
                  alt='Zento Banner'
                  loading='lazy'
                  width='960'
                  height='960'
                />
              </picture>
            </div>
          </div>
        </div>
    </div>;
  }
}
